<div *ngIf="sector" class="flight-detail-container">
  <ng-container *ngFor="let flight of sector.Flights; index as i">
    <app-travel-info
      [airlineCode]="flight.AirlineCode"
      [airlineName]="flight.AirlineName"
      [opAirlineCode]="flight.OpAirlineCode"
      [opAirlineName]="flight.OpAirlineName"
      [number]="flight.Number"
      [isMobile]="isMobile"
      [flightTimeInternal]="flight.FlightTimeInternal"
      [departureDate]="flight.DepartureDate"
      [departureAirport]="flight.DepartureAirport"
      [arrivalDate]="flight.ArrivalDate"
      [arrivalAirport]="flight.ArrivalAirport"
      [airplane]="flight.Equipment"
      [flightClass]="flightClass"
      [fareFamilies]="flight.FareFamilies"
      [cabin]="flight.Cabin"
      [isLoadingCabinDetail]="isLoadingCabinDetail"
      [cabinAmenitie]="getCabinAmenitie(i)"
      [isLoggedIn]="isLoggedIn"
      [isLoadingFlightCabin]="isLoadingFlightCabin"
      [flightCabinSelected]="flightCabinSelected"
      (openCabinDetail)="openCabinDetail.emit($event)">
      <ng-container *ngIf="!!isMobile">
        <app-luggage-tooltip
          luggageTooltip
          [handBaggage]="!!flight.HandBaggage"
          [airline]="flight.AirlineCode"
          [fareFamily]="flight.FareFamilies"
          [fareBasis]="flight.FareBasis"
          [baggage]="flight.BaggageRestrictions | luggage"
          [typeOfLuggage]="flight.BaggageRestrictions | typeLuggage"
          [showArrow]="false"
          [showShadow]="false"
          [departureDate]="flight.DepartureDate"
          [departureAirport]="flight.DepartureAirport"
          [arrivalAirport]="flight.ArrivalAirport"
          [isInternational]="isInternational">
        </app-luggage-tooltip>
      </ng-container>
    </app-travel-info>
    <app-flight-segment-connection
      [hasScales]="hasScales"
      [provider]="provider"
      [isScaleElement]="isScaleElement(i)"
      [isConnectionInDifferentAirport]="flight.IsConnectionInDifferentAirport"
      [numberOfStops]="flight.NumberOfStops"
      [totalDuration]="sector.TotalDuration"
      [technicalStopAirport]="flight.TechnicalStopAirport"
      [technicalStopTime]="flight.TechnicalStopTime"
      [flight]="flightItem(i)"
      [nextFlight]="nextFlightItem(i)">
    </app-flight-segment-connection>
  </ng-container>
</div>

